import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_ALERTS } from 'actions/alerts';

function* fetchAlerts(action) {
  try {
    const response = yield call(API.getAlerts, action.payload);
    yield put({ type: FETCH_ALERTS.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_ALERTS.FAIL, payload: { error: e } });
  }
}

function* alerts() {
  yield takeLatest(FETCH_ALERTS.REQUEST, fetchAlerts);
}
export default alerts;
